import React, { useRef } from 'react'

const UploadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="17 8 12 3 7 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="12" y1="3" x2="12" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

interface WizardFileUploadProps {
  label?: string
  hint?: string
  accept?: string
  files: File[]
  onChange: (files: File[]) => void
}

const WizardFileUpload = ({
  label = 'Attachments',
  hint = 'JPG, PNG, PDF, MP4 — up to 25 MB each',
  accept = '.jpg,.jpeg,.png,.pdf,.mp4',
  files,
  onChange,
}: WizardFileUploadProps) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const handleFiles = (newFiles: FileList | null) => {
    if (!newFiles) return
    onChange([...files, ...Array.from(newFiles)])
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
      <label style={{ fontSize: '0.875rem', fontWeight: 600, color: '#0a0d47' }}>
        {label} <span style={{ fontSize: '0.8125rem', fontWeight: 400, color: '#9ca3af' }}>(optional)</span>
      </label>
      <div
        onClick={() => inputRef.current?.click()}
        style={{
          border: '1.5px dashed #a5b4fc',
          borderRadius: '10px',
          padding: '32px 16px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '8px',
          cursor: 'pointer',
          backgroundColor: '#fafafa',
        }}
      >
        <span style={{ color: '#6b7280' }}><UploadIcon /></span>
        <span style={{ fontSize: '0.875rem', color: '#374151', fontWeight: 500 }}>Click to upload files</span>
        <span style={{ fontSize: '0.75rem', color: '#9ca3af' }}>{hint}</span>
      </div>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        multiple
        style={{ display: 'none' }}
        onChange={(e) => handleFiles(e.target.files)}
      />
      {files.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginTop: '4px' }}>
          {files.map((file, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '0.8125rem', color: '#374151', padding: '4px 8px', backgroundColor: '#f9fafb', borderRadius: '6px' }}>
              <span>{file.name}</span>
              <button
                type="button"
                onClick={() => onChange(files.filter((_, fi) => fi !== i))}
                style={{ background: 'none', border: 'none', color: '#9ca3af', cursor: 'pointer', fontSize: '1rem', lineHeight: 1 }}
              >×</button>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default WizardFileUpload
